import { api } from "@/lib/api";

export interface MemoryStats {
    enabled: boolean;
    conversations?: number;
    messages?: number;
    messageEmbeddings?: number;
    knowledgeNodes?: number;
    claims?: number;
    embeddingModel?: string;
}

export interface MemoryConversation {
    id: number;
    scopeKind: string;
    scopeRef: string;
    userId: number;
    title: string | null;
    startedAt: string;
    lastActivityAt: string;
    messageCount: number;
}

export interface MemoryHit {
    id: number;
    kind: "message" | "node";
    conversationId: number;
    role: string;
    content: string;
    snippet: string | null;
    vectorScore: number;
    lexicalScore: number;
    rrfScore: number;
    createdAt: string;
    scopeKind: string;
    scopeRef: string;
}

export async function getMemoryStats(): Promise<MemoryStats> {
    const { data } = await api.get<MemoryStats>("/admin/memory/stats");
    return data;
}

export async function listMemoryConversations(scope?: { kind: string; ref: string }): Promise<MemoryConversation[]> {
    const { data } = await api.get<MemoryConversation[]>("/admin/memory/conversations", {
        params: scope ? { scopeKind: scope.kind, scopeRef: scope.ref } : {},
    });
    return data;
}

export async function searchMemory(q: string, scope?: { kind: string; ref: string }, limit = 20): Promise<{ hits: MemoryHit[] }> {
    const { data } = await api.get<{ hits: MemoryHit[] }>("/admin/memory/search", {
        params: { q, limit, ...(scope ? { scopeKind: scope.kind, scopeRef: scope.ref } : {}) },
    });
    return data;
}
